import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "input-container w-[350px] p-5 flex flex-col bg-[#f5f7f9] h-full items-start overflow-hidden"
};
const _hoisted_2 = {
  class: "flex-grow overflow-y-auto"
};
const _hoisted_3 = {
  class: "mt-[10px]"
};
const _hoisted_4 = {
  class: "mt-[30px]"
};
import { MindMapContentExample } from '@/views/aip/utils/constants';
import { reactive, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Left',
  props: {
    isGenerating: {
      type: Boolean
    }
  },
  emits: ['submit', 'directGenerate'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    // 提交的提示词字段
    const formData = reactive({
      prompt: ''
    });
    const generatedContent = ref(MindMapContentExample); // 已有的内容
    __expose({
      setGeneratedContent(newContent) {
        // 设置已有的内容，在生成结束的时候将结果赋值给该值
        generatedContent.value = newContent;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("h3", {
        class: "w-full h-7 text-5 text-center leading-[28px] title"
      }, "思维导图创作", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("您的需求？")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: formData.prompt,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.prompt = $event),
        maxlength: "1024",
        rows: 5,
        class: "w-100% mt-[10px]",
        "input-style": "border-radius: 7px;",
        placeholder: "请输入提示词，让AI帮你完善",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "!w-full mt-[15px]",
        type: "primary",
        loading: _ctx.isGenerating,
        onClick: _cache[1] || (_cache[1] = $event => emits('submit', formData))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 智能生成思维导图 ")])),
        _: 1
      }, 8, ["loading"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_text, {
        tag: "b"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("使用已有内容生成？")])),
        _: 1
      }), _createVNode(_component_el_input, {
        modelValue: generatedContent.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => generatedContent.value = $event),
        maxlength: "1024",
        rows: 15,
        class: "w-100% mt-[10px]",
        "input-style": "border-radius: 7px;",
        placeholder: "例如：童话里的小屋应该是什么样子？",
        "show-word-limit": "",
        type: "textarea"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "!w-full mt-[15px]",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => emits('directGenerate', generatedContent.value)),
        disabled: _ctx.isGenerating
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 直接生成 ")])),
        _: 1
      }, 8, ["disabled"])])])]);
    };
  }
});